export default __webpack_public_path__ + "static/1-36-0-multi-point-persons-modal-09d065ef98c5da678d53d5a5c771d0d3.gif";